import * as R from "ramda";

const useFormatMoney = () => ({
	formatMoney: ({
		priceCents,
		displayPrice
	}: {
		priceCents?: undefined | null | number;
		displayPrice?: undefined | null | string;
	}): string => {
		if (!R.isNil(displayPrice)) {
			return displayPrice;
		}

		if (!R.isNil(priceCents)) {
			const amount = priceCents / 100;
			if (amount % 1 > 0) {
				return `$${amount.toFixed(2)}`;
			} else {
				return `$${amount}`;
			}
		}

		return "";
	}
});

export default useFormatMoney;
